export default "__VITE_ASSET__BvXKLuV___"